import { api } from '@/lib/customFetch'
import type { AreaNode, AreaDetail, Area, CreateAreaInput, UpdateAreaInput, MoveAreaInput, DocumentTypeWithCount } from '@/lib/types/ged'

export const areaKeys = {
  tree: () => ['areas', 'tree'] as const,
  detail: (id: string) => ['areas', id] as const,
  detailBySlug: (slug: string) => ['areas', 'by-slug', slug] as const,
  documentTypes: (id: string) => ['areas', id, 'document-types'] as const,
}

export async function getAreaTree(): Promise<AreaNode[]> {
  return api.get<AreaNode[]>('/documents/areas/tree')
}

export async function getAreaDetail(id: string): Promise<AreaDetail> {
  return api.get<AreaDetail>(`/documents/areas/${id}`)
}

export async function getAreaBySlug(slug: string): Promise<AreaDetail> {
  return api.get<AreaDetail>(`/documents/areas/by-slug/${encodeURIComponent(slug)}`)
}

export async function createArea(data: CreateAreaInput): Promise<Area> {
  return api.post<Area>('/documents/areas', data)
}

export async function updateArea(id: string, data: UpdateAreaInput): Promise<Area> {
  return api.patch<Area>(`/documents/areas/${id}`, data)
}

export async function deleteArea(id: string): Promise<void> {
  return api.delete<void>(`/documents/areas/${id}`)
}

export async function moveArea(id: string, data: MoveAreaInput): Promise<void> {
  return api.post<void>(`/documents/areas/${id}/move`, data)
}

export async function archiveArea(id: string): Promise<void> {
  return api.post<void>(`/documents/areas/${id}/archive`)
}

export async function unarchiveArea(id: string): Promise<void> {
  return api.post<void>(`/documents/areas/${id}/unarchive`)
}

export async function getAreaDocumentTypes(id: string): Promise<DocumentTypeWithCount[]> {
  return api.get<DocumentTypeWithCount[]>(`/documents/areas/${id}/document-types`)
}
